import type { ResolveTooltipAnchoring } from "./types";

const TOOLTIP_ESTIMATED_HEIGHT = 80;
const TOOLTIP_OFFSET = 6;

export const resolveTooltipAnchoring: ResolveTooltipAnchoring = ({
  anchorRect,
}) => {
  // Flip above the anchor when there isn't room below and above has more.
  const spaceBelow = window.innerHeight - anchorRect.bottom;
  const placement =
    spaceBelow < TOOLTIP_ESTIMATED_HEIGHT && anchorRect.top > spaceBelow
      ? "top"
      : "bottom";
  const top =
    placement === "bottom"
      ? anchorRect.bottom + window.scrollY + TOOLTIP_OFFSET
      : anchorRect.top + window.scrollY - TOOLTIP_OFFSET;

  return {
    top,
    placement,
    anchorCenterX: anchorRect.left + anchorRect.width / 2,
  };
};
